import { render, staticRenderFns } from "./PartnerSharedContentAccessDetail.vue?vue&type=template&id=1475235c&scoped=true&"
import script from "./PartnerSharedContentAccessDetail.vue?vue&type=script&lang=ts&"
export * from "./PartnerSharedContentAccessDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerSharedContentAccessDetail.vue?vue&type=style&index=0&id=1475235c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1475235c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VBtn,VCard,VCol,VDivider,VIcon,VRow,VSkeletonLoader,VTimeline,VTimelineItem})
